<template>
  <div :class="{ red: !!errmsg }">
    <div style="width: 100vw; height: 0px;" :id="domId"></div>
    <slot />
    <div style="color: #EE0A24;padding-left: 20px;text-align: left;">{{ errmsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'ErrTip',
  components: {},
  props: {
    domId: {
      type: String,
      default: '',
    },
    errmsg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  setup() {

  },
};
</script>

<style scoped lang="less">
.red {
  border: 1px solid #EE0A24 !important;
}
</style>
